import { useState } from "react";
import { ServiceWorkerType, eNAEPComponents } from "../typings";
import { isLocalhost } from "../util";
import { useDedupEffect } from "../hooks/useDedupEffect";
import { useDispatch } from "react-redux";
import { createFailureAction, createUpdatePreChacheValidationStatusAction, createUpdateServiceWorkerDetailsAction } from "../state/reducer";
import { indexDBStorage } from "../storage/indexDBStorage";

export function useServiceWorkerRegistration(component?:eNAEPComponents){
  const dispatch = useDispatch()
  const [serviceWorkerRegistration, setServiceWorkerRegistration] = useState<boolean[] | undefined>(undefined);
// This optional code is used to register a service worker.
// register() is not called by default.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.

// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://cra.link/PWA
const logPrefix= "[ADPServiceWorker]"

type Config = {
  onSuccess?: (registration: ServiceWorkerRegistration) => void;
  onUpdate?: (registration: ServiceWorkerRegistration) => void;
  scope?: string;
  appName: eNAEPComponents
};

 function getConfig(appName: eNAEPComponents, scope?: string) {
  const config = {
    scope,
    appName,
    onSuccess : (registration:ServiceWorkerRegistration)=>{
      console.log(`[${appName}][serviceWorker] Service Worker Loaded`);
      
    },
    onUpdate:(registration:ServiceWorkerRegistration)=>{
      console.log(`[${appName}][serviceWorker] Update Found,notify client`,registration);
      registration?.waiting?.postMessage({type: 'SKIP_WAITING'});
    }
  }
  return config;
} 

 async function register() {
  if ('serviceWorker' in navigator) {
    // The URL constructor is available in all browsers that support SW.
    // @ts-ignore - Env check is needed to ensure PUBLIC_URL is defined
    const publicUrl = new URL(import.meta.env.BASE_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      // Our service worker won't work if PUBLIC_URL is on a different origin
      // from what our page is served on. This might happen if a CDN is used to
      // serve assets; see https://github.com/facebook/create-react-app/issues/2374
      return;
    }

   // window.addEventListener('load', () => {
    // const swUrl = `./service-worker.js`;
    const swUrl = `${import.meta.env.BASE_URL}service-worker.js`;
    console.log('swUrl',swUrl)
    const adcSwUrl = `${self.location.origin}/ade/service-worker.js`;
      const sciSwUrl = `${self.location.origin}/login/service-worker.js`;

      if (isLocalhost()) {
        // This is running on localhost. Let's check if a service worker still exists or not.
        //checkValidServiceWorker(swUrl, getConfig(eNAEPComponents.ADP));
        navigator.serviceWorker.ready.then(() => {
          console.log(logPrefix,
            'This web app is being served cache-first by a service ' +
              'worker. To learn more, visit https://cra.link/PWA'
          );
        });
        setServiceWorkerRegistration([true]);
        dispatch(createUpdatePreChacheValidationStatusAction({
          validationStatus: "Skipped",
          validationDetails: "running on localhost"
        }));
      } else {
        //register only ADP for npn mode
         if(component && component === eNAEPComponents.ADP_NPN){
          const adpPromise = registerValidSW(swUrl, getConfig(eNAEPComponents.ADP_NPN));
          const registration = await Promise.all([adpPromise]);
          setServiceWorkerRegistration(registration);
        }
        else {
          const adpPromise = await registerValidSW(swUrl, getConfig(eNAEPComponents.ADP));
          const adcPromise = await registerValidSW(adcSwUrl, getConfig(eNAEPComponents.ADC, '/'));
          const sciPromise = await registerValidSW(sciSwUrl, getConfig(eNAEPComponents.SCI, '/login/'))
         // const registration = await Promise.all([adpPromise, adcPromise, sciPromise]);
          setServiceWorkerRegistration([adpPromise,adcPromise,sciPromise]);  
        }
      }
    //});
  }
}

function registerValidSW(swUrl: string, config: Config) {
    return new Promise<boolean>(function (resolve) {
        console.log(logPrefix,"RegisterVaidSW", swUrl);
        navigator.serviceWorker
          .register(swUrl, { updateViaCache: 'none', scope: config?.scope })
          .then((registration) => {
            if (registration.installing) {
              console.log(logPrefix,"[RegisterVaidSW] installing", config?.scope, registration.installing);
            } else if (registration.waiting) {
              console.log(logPrefix,"[RegisterVaidSW] waiting",  config?.scope, registration.waiting);
            } else if (registration.active) {
              console.log(logPrefix,"[RegisterVaidSW] active",  config?.scope, registration.active);
            }
            registration.onupdatefound = () => {
              const installingWorker = registration.installing;
              if (installingWorker == null) {
                return;
              }
              installingWorker.onstatechange = () => {
                  const serviceWorkerDetails: ServiceWorkerType = {
                      appCode: config.appName,
                      registrationStatus: installingWorker.state
                    }
                    dispatch(createUpdateServiceWorkerDetailsAction(serviceWorkerDetails));
                    if (installingWorker.state === 'redundant') {
                      console.error('Service Worker installation failed and became redundant.');
                      autoRecoveryOnFailure();
                    }
                }
              if (installingWorker.state === 'installed') {
                  if (navigator.serviceWorker.controller) {
                    if (config && config.onUpdate) {
                      config.onUpdate(registration);
                    }
                  } else {
                    console.log(logPrefix,'Content is cached for offline use.', swUrl);
                    if (config && config.onSuccess) {
                      config.onSuccess(registration);
                  }
                };
              };
            };
            resolve(true);
                // Listen for messages from the service worker
          navigator.serviceWorker.addEventListener('message', async event => {
            if (event.data && event.data.type === "SERVICE_WORKER_INSTALLATION_ERROR") {
              console.error("Error from Service Worker:", event.data.message);
              const serviceWorkerDetails: ServiceWorkerType = {
                appCode: config.appName,
                registrationStatus: event.data.message
              }
              dispatch(createUpdateServiceWorkerDetailsAction(serviceWorkerDetails));
            }
            await autoRecoveryOnFailure();
            resolve(false);
          });
          }).catch(async (error) => {
            console.error(logPrefix,'Error during service worker registration:', error);
            const serviceWorkerDetails: ServiceWorkerType = {
              appCode: config.appName,
              registrationStatus: `Error during service worker registration ${error}`
            }
            dispatch(createUpdateServiceWorkerDetailsAction(serviceWorkerDetails));
            //
            dispatch(createFailureAction("SystemError"));
           // await autoRecoveryOnFailure();
            resolve(false);
          });
    });
}
  async function autoRecoveryOnFailure (){
    try {
      const swRegistrationAttempt = await (await indexDBStorage.getInstance()).transactions.get("adp-session-references","swRegistrationAttempt"); 
      if(swRegistrationAttempt === 3){
       dispatch(createFailureAction("SystemError"));
        //await (await indexDBStorage.getInstance()).transactions.delete("adp-session-references","swRegistrationAttempt"); 
        return;
      }
      else {
        const attempt = swRegistrationAttempt ? swRegistrationAttempt + 1 : 1
        await (await indexDBStorage.getInstance()).transactions.put("adp-session-references", attempt, "swRegistrationAttempt"); 
      }
      if ('serviceWorker' in navigator) {    
      try {
        const registrations =  await navigator.serviceWorker.getRegistrations();
       for (let registration of registrations) {
        registration.unregister();
        }
      }
       catch(error){
            console.error('Error while unregistering service workers:', error);
        };
      /*   
        try {
          const cacheNames = await caches?.keys();
          for (let cacheName of cacheNames) {
            caches.delete(cacheName);
            }
          }
          catch(e){
            console.error('Error while removing cache:', e); 
          } */
        }    
       window.location.reload();
      } 
   
    catch(e){
      console.error('Error recovering from service worker failure:', e);
      dispatch(createFailureAction("SystemError"));
    }
  }
 
function checkValidServiceWorker(swUrl: string, config: Config) {
  // Check if the service worker can be found. If it can't reload the page.
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then(async (response) => {
      // Ensure service worker exists, and that we really are getting a JS file.
      const contentType = response.headers.get('content-type');
      if (response.status === 404 ||  (contentType != null && contentType.indexOf('javascript') === -1)) {
        // No service worker found. Probably a different app. Reload the page.
         await autoRecoveryOnFailure();
      } else {
        // Service worker found. Proceed as normal.
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log(logPrefix,'No internet connection found. App is running in offline mode.');
    });
}

 function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
useDedupEffect(() => {
     register();
  }, []);
return {serviceWorkerRegistration,unregister}
}
